<template>
  <div class="pc_container app-main-content">
    <div class="app-main-content-section bgfff pos">
      <div class="flex flex_items flex_center">
        <el-input style="width: 400px;" class="mr20" v-model="keyword" placeholder="请输入订单号/票码/游客电话/游客身份证号"
          @keyup.enter.native="search"></el-input>
        <el-button type="primary" @click="search">查询</el-button>
        <el-button type="primary" @click="clear">清空</el-button>
      </div>
      <div>
        <el-table :data="list" class="mt20" style="width: 100%" :header-cell-style="{
          background: '#F3F3F3', color: '#1F3349', fontSize: '15px', fontWeight: 'normal',
        }" :cell-style="{ fontSize: '15px', color: '#666666' }" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="100" />
          <el-table-column prop="ticket.name" label="门票" width="200" />
          <el-table-column prop="sn" label="票码" />
          <el-table-column prop="index" label="序号" />
          <el-table-column prop="price" label="价格" />
          <el-table-column prop="play_date" label="支付日期" />
          <el-table-column prop="num" label="状态">
            <template slot-scope="scope">
              {{ scope.row.status == 0 ? '待使用' : scope.row.status == 1 ? '已使用' : scope.row.status == -1 ? '已退款' : '' }}
            </template>
          </el-table-column>
          <div slot="empty" style="text-align: center;width:100%">
            暂无数据
          </div>
        </el-table>
      </div>


    </div>
    <div class="flex flex_end end-silder flex_items">
      <el-button type="primary" style="width: 150px;height: 50px;font-size: 20px;" @click="makeup">确定补打</el-button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      page: 1,
      keyword: '',
      tourist_certificate: {},
      list: [],
      keyword: '',
      choseArr: []
    };
  },

  methods: {
    goto(url) {
      this.$router.push(url)
    },
    clear() {
      this.keyword = ''
      this.choseArr = []
      this.search()
    },
    search() {
      this.api.getUrl('/api/v1/window/makeup/list', { keyword: this.keyword }).then(res => {
        this.list = res.list
      })
    },
    makeup() {
      if (this.choseArr.length == 0) return this.$message.error('请选择要补打的门票');
      let ids = this.choseArr.map(r => {
        return r.id
      })
      this.api.getUrl('/api/v1/window/printerStatus').then(res => {
        if (res.status != 1) {
          this.$alert('<strong style="color:#ed2222;">打印机没有连接</strong>', '注意！', {
            dangerouslyUseHTMLString: true,
            showClose: false
          });
        } else if(res.status == 1){
          this.api.postUrl('/api/v1/window/makeup', { ids: ids }, { loading: true })
            .then((res) => {
              this.$message.success('操作成功');
            });
        }
      })
    },
    handleSelectionChange(e) {
      this.choseArr = e;
    },
  },
  created() {
    this.search()
  },
};
</script>
<style scoped>
.end-silder {
  position: absolute;
  bottom: 0;
  left: 130px;
  height: 80px;
  background: #f3eded;
  width: calc(100% - 130px);
  padding-right: 30px;
  box-sizing: border-box;
}
</style>
